import { useQueryClient } from '@tanstack/react-query';
import { RISK_MANAGEMENT_LAST_CONSULTATIONS_QUERY_KEY } from 'hooks/queries/useGetRiskManagementLastConsultations';
import { SEARCH_TRUCKER_KEY } from 'hooks/queries/useOpenSearchQuery';
import { TRUCKER_PROFILE_KEY } from 'hooks/queries/useTruckerProfileQuery';
import { useTruckerProps } from 'hooks/useTruckerProps';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import ContactListFeatures from 'services/contactList/types';
import { IFeatureFlagrResponse } from 'services/featureFlagr';
import { IRiskManagementLastConsultationsResponse } from 'services/riskManagement/types';
import { QUERY_FLAGR_KEY } from 'services/searchTrucker/constants';

const useGetTruckerQueriesData = () => {
  const { truckerId } = useTruckerProps();
  const queryClient = useQueryClient();

  const truckerData: ITruckerProfileProps = queryClient.getQueryData([TRUCKER_PROFILE_KEY, truckerId]);

  const openSearchTruckerData: ITruckerProfileProps = queryClient.getQueryData([SEARCH_TRUCKER_KEY]);

  const contactListFeatureData: IFeatureFlagrResponse = queryClient.getQueryData([
    QUERY_FLAGR_KEY,
    ContactListFeatures.CONTACT_LIST,
  ]);
  const getRiskManagementLasConsultationsData: IRiskManagementLastConsultationsResponse = queryClient.getQueryData([
    RISK_MANAGEMENT_LAST_CONSULTATIONS_QUERY_KEY,
  ]);

  return { truckerData, openSearchTruckerData, contactListFeatureData, getRiskManagementLasConsultationsData };
};

export { useGetTruckerQueriesData };
